/**
 * created by wang lei
 上标页面
 *
 */
import React, {Component} from 'react';
import superscript from './superscript.png';
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";
import {toolWidth} from "../../twoLinesEditorToolsSpace";

export default class SuperscriptTool extends Component {
    constructor(props) {
        super(props);
        this.state = {
            btnChecked:false
        }
    }
    /**
     * 监听内容变化
     */
    listenContentChange(){
        let superscript = this.props.editor.queryCommandState("superscript");
        this.setState({btnChecked: superscript === 1});
    }

    /**
     * 监听编辑器点击
     */
    listenContentClick(){
        let superscript = this.props.editor.queryCommandState("superscript");
        this.setState({btnChecked: superscript === 1});
    }
    render() {
        let style = {};
        if(this.state.btnChecked){
            style.boxShadow = `-1px -1px ${EDITOR_TOOL_BTN_COLOR.checked}`;
        }else{
            if(style.boxShadow){
                delete style.boxShadow;
            }
        }
        return (
            <span style={{cursor:"pointer"}} onClick={()=>{
                this.props.editor.execCommand( 'superscript' );
                this.setState({btnChecked: !this.state.btnChecked});
            }}>
                <img  className={"editor-superscript-tool-btn"} style={style} width={toolWidth - 2} src={superscript}/>
                <style>{`
                .editor-superscript-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-superscript-tool-btn:hover{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                }
                .editor-superscript-tool-btn:active{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                }
            `}</style>
            </span>
        )
    }

}